import { CommonModule } from '@angular/common';
import { Component, ContentChild, TemplateRef, input, isSignal, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { HeaderIconButton } from '@vectronic/util';
import { baseHref } from '../../utils/configs/baseHref';

@Component({
  selector: 'vectronic-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    MtxPopoverModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
})
export class CardComponent {
  isSignal = isSignal;
  title = input<string>();
  subTitle = input<string>();
  headerIconButtons = input<HeaderIconButton[]>();
  showHeader = input(true);
  displayCollarDeploymentInfographic = input<boolean>();
  shadowMargin = input<boolean>();
  displayClose = input<boolean>();
  showResize = input(false);
  closeIcon = input<string>('close');

  closed = output<void>();
  resized = output<boolean>();

  @ContentChild('cardButtons') cardButtons: TemplateRef<any>;

  isFullScreen = false;
  collarDeploymentInfograficSrc = baseHref + 'assets/img/collar-deployment-infographic.png';

  onClose() {
    this.closed.emit();
  }

  onResize() {
    this.isFullScreen = !this.isFullScreen;
    this.resized.emit(this.isFullScreen);
  }
}
